import {Code} from "../../common/code/types";
import {PayloadAction} from "@reduxjs/toolkit";

export interface CodeState {
    code: Code
}

export enum CodeActionType {
    SETCODE = "SETCODE"
}

export type SetCodeAction = PayloadAction<Code, CodeActionType.SETCODE>
export type CodeAction = SetCodeAction;